const getCountryFromGeoCode = (
  addrComponents: google.maps.GeocoderResult[],
) => {
  for ( const addrComponent of addrComponents) {
    if (addrComponent.types[0] === 'country') {
      return {
        name: addrComponent?.address_components[0].long_name,
        isoCode: addrComponent?.address_components[0].short_name,
      };
    }
    if (addrComponent.types.length === 2) {
      // FIXME: This is temporory fix
      if (addrComponent?.address_components[0].short_name === 'Aglantzia') {
        return {
          name: 'Cyprus',
          isoCode: 'CY'
        }
      }
      if (addrComponent.types[0] === 'political') {	
        return {
          name: addrComponent?.address_components[0].long_name,
          isoCode: addrComponent?.address_components[0].short_name,
        };
      }
    }
  }
  return {name: undefined, isoCode: undefined};
};

export default getCountryFromGeoCode;
